import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { VisitorProvider } from "@/lib/visitor";
import { ContentProvider } from "@/lib/content-store";
import EventPage from "@/pages/EventPage";
import EventsPage from "@/pages/EventsPage";
import Worship from "@/pages/Worship";
import InfoPage from "@/pages/InfoPage";
import Home from "@/pages/Home";
import Devotionals from "@/pages/Devotionals";
import PastoralResponse from "@/pages/PastoralResponse";
import Communities from "@/pages/Communities";
import CommunityPage from "@/pages/CommunityPage";
import RecordDevotional from "@/pages/RecordDevotional";
import StaffHub from "@/pages/StaffHub";
import Journey from "@/pages/Journey";

function App() {
  return (
    <BrowserRouter>
      <ContentProvider>
      <VisitorProvider>
        <Routes>
          <Route path="/events/:id" element={<EventPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/worship" element={<Worship />} />
          <Route path="/connect" element={<InfoPage key="connect" pageKey="connect" />} />
          <Route path="/discipleship/make-disciples" element={<InfoPage key="md" pageKey="make-disciples" />} />
          <Route path="/discipleship/be-discipled" element={<InfoPage key="bd" pageKey="be-discipled" />} />
          <Route path="/journey" element={<Journey />} />
          <Route path="/pastoral-care" element={<InfoPage key="pc" pageKey="pastoral-care" />} />
          <Route path="/" element={<Home />} />
          <Route path="/devotionals" element={<Devotionals />} />
          <Route path="/staff" element={<StaffHub />} />
          <Route path="/communities" element={<Communities />} />
          <Route path="/communities/:slug" element={<CommunityPage />} />
          <Route path="/record" element={<RecordDevotional />} />
          <Route path="/pastoral-response/:token" element={<PastoralResponse />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </VisitorProvider>
      </ContentProvider>
    </BrowserRouter>
  );
}

export default App;
